module.exports = __webpack_public_path__ + "static/media/logoUM.cba83bde.png";